import { createSlice } from "@reduxjs/toolkit";

const parametrosBasicosSlice = createSlice({
  name: "basic_parameters",
  initialState: {
    currentParametrosBasicos: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    parametros_basicoStart: (state) => {
      state.isFetching = true;
    },
    parametros_basicoSuccess: (state, action) => {
      state.isFetching = false;
      state.currentParametrosBasicos = action.payload;
    },
    parametros_basicFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    createParametro_basicoStart: (state) => {
        state.isFetching = true;
    },
    createParametro_basicoSuccess: (state, action) => {
      state.isFetching = false;
      state.currentParametrosBasicos = [
          ...(state.currentParametrosBasicos || []), // Mantiene los existentes
          action.payload.data // Agrega el nuevo parámetro
      ];
      state.errorCreate = false;
  },
  
    createParametro_basicoFailure: (state) => {
        state.isFetching = false;
        state.errorCreate = true;
    },
    logoutInfoparametros_basico: (state) => {
      state.currentParametrosBasicos = null;
      state.isFetching = false;
      state.error = false;
      state.errorCreate = false;
    },
  },
});

export const {
  parametros_basicoStart,
  parametros_basicoSuccess,
  parametros_basicoFailure,
  createParametro_basicoStart, 
  createParametro_basicoSuccess, 
  createParametro_basicoFailure,
  logoutInfoparametros_basico
} = parametrosBasicosSlice.actions;
export default parametrosBasicosSlice.reducer;
